export const generateGymTvSocketChannelName = (gymId, roomNumber) => `private-gym.${gymId}.room.${roomNumber}`;



// WEBPACK FOOTER //
// ./src/Services/utils.js